import { render } from "./TopicSuggestion.vue?vue&type=template&id=03e08725&scoped=true"
import script from "./TopicSuggestion.vue?vue&type=script&lang=js"
export * from "./TopicSuggestion.vue?vue&type=script&lang=js"

import "./TopicSuggestion.vue?vue&type=style&index=0&id=03e08725&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e08725"]])

export default __exports__